import { render, staticRenderFns } from "./GymRoutePicture.vue?vue&type=template&id=2fa2a4df"
import script from "./GymRoutePicture.vue?vue&type=script&lang=js"
export * from "./GymRoutePicture.vue?vue&type=script&lang=js"
import style0 from "./GymRoutePicture.vue?vue&type=style&index=0&id=2fa2a4df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports